var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgInfo = function SvgInfo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 39H21V27h-4.5a4.49 4.49 0 0 1-4.5-4.5 4.49 4.49 0 0 1 4.5-4.5h9a4.49 4.49 0 0 1 4.5 4.5V39h1.5a4.49 4.49 0 0 1 4.5 4.5 4.49 4.49 0 0 1-4.5 4.5h-15a4.49 4.49 0 0 1-4.5-4.5 4.49 4.49 0 0 1 4.5-4.5ZM24 12c-3.319 0-6-2.681-6-6s2.681-6 6-6 6 2.681 6 6-2.681 6-6 6Z"
  })));
};
export default SvgInfo;